

import React from 'react'
import { useFormDetails } from '../../hooks/useFormDetails';


type IProps = {
  closeModal: () => void
}
export default function OneKBInitiativeIntakeForm({
  closeModal
}: IProps) {


  const {
    formTitle,
    formSrc,
  } = useFormDetails();


  return (
    <div>
      <iframe
        width="640px"
        height="480px"
        src={formSrc}
        frameBorder={0}
        marginWidth={0}
        marginHeight={0}
        style={{
          border: "none",
          minHeight: "600px",
          maxWidth: "100%",
          maxHeight: "100vh"
        }}
        allowFullScreen={true}
        title={formTitle}
      >
        {" "}
      </iframe>

    </div>
  )
}
